var _circle, _circle2, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgC2C({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 7.85502,
    cy: 5.3472,
    r: 1.60502,
    fill: "currentColor"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 16.5489,
    cy: 11.899,
    r: 1.60502,
    fill: "currentColor"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.2535 13.255V10.8565C10.2535 9.53185 9.1797 8.45801 7.85504 8.45801V8.45801C6.53039 8.45801 5.45654 9.53185 5.45654 10.8565V13.255",
    stroke: "currentColor",
    strokeWidth: 1.6
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9474 19.8068V17.4083C18.9474 16.0836 17.8735 15.0098 16.5489 15.0098V15.0098C15.2242 15.0098 14.1504 16.0836 14.1504 17.4083V19.8068",
    stroke: "currentColor",
    strokeWidth: 1.6
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1539 9.15784V5.65625H14.6523",
    stroke: "currentColor",
    strokeWidth: 1.6
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1499 5.65588L15.6035 4.16699V7.14478L13.1499 5.65588Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5.45642 15.2885V18.79H8.95801",
    stroke: "currentColor",
    strokeWidth: 1.6
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M10.46 18.7904L8.00635 20.2793V17.3015L10.46 18.7904Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgC2C);
export default __webpack_public_path__ + "static/media/c2c.0ee85d0053c1f5cf3acbcf125d524d46.svg";
export { ForwardRef as ReactComponent };